// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");

function QuestionText(props) {
  var substitutionVariables = props.substitutionVariables;
  var mandatory = props.mandatory;
  var description = props.description;
  var text = props.text;
  var multiLineCss = " whitespace-pre-line";
  var useSubstitution = Belt_Option.isSome(substitutionVariables);
  var match = substitutionVariables !== undefined ? [
      Substitution$ReactHooksTemplate.renderQuestionText(text, substitutionVariables) + (
        mandatory ? " *" : ""
      ),
      Substitution$ReactHooksTemplate.renderQuestionText(description, substitutionVariables)
    ] : [
      mandatory ? text + " *" : text,
      description
    ];
  var descriptionHtml = match[1];
  var titleHtml = match[0];
  var match$1 = SurveyTheme$ReactHooksTemplate.name(props.surveyTheme);
  if (match$1 === "bhima") {
    if (useSubstitution) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          className: "survey-rich-text text-2xl small:text-lg small:py-5 font-semibold\n        mb-4 small:mb-2 " + multiLineCss,
                          dangerouslySetInnerHTML: {
                            __html: titleHtml
                          }
                        }),
                    JsxRuntime.jsx("div", {
                          className: "survey-rich-text text-base mb-12 small:mb-4 " + multiLineCss,
                          dangerouslySetInnerHTML: {
                            __html: descriptionHtml
                          }
                        })
                  ],
                  className: "flex flex-col"
                });
    } else {
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                          children: titleHtml,
                          className: " text-2xl small:text-lg small:py-5 font-semibold\n        mb-4 small:mb-2 " + multiLineCss
                        }),
                    JsxRuntime.jsx("p", {
                          children: descriptionHtml,
                          className: " text-base mb-12 small:mb-4 " + multiLineCss
                        })
                  ],
                  className: "flex flex-col"
                });
    }
  } else if (useSubstitution) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text font-normal text-lg leading-8 tracking-0.8 small:text-base\n          small:leading-6 small:tracking-wide" + multiLineCss,
                              dangerouslySetInnerHTML: {
                                __html: titleHtml
                              }
                            }),
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-base small:text-xs mt-10-px pt-3 " + multiLineCss,
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            })
                      ],
                      className: "flex flex-col items-start mb-8 small:mb-6"
                    }),
                className: "w-full pt-8 px-16 small:px-6"
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: titleHtml,
                              className: " font-normal text-lg leading-8 tracking-0.8 small:text-base\n          small:leading-6 small:tracking-wide" + multiLineCss
                            }),
                        JsxRuntime.jsx("p", {
                              children: descriptionHtml,
                              className: " text-base small:text-xs mt-10-px pt-3 " + multiLineCss
                            })
                      ],
                      className: "flex flex-col items-start mb-8 small:mb-6"
                    }),
                className: "w-full pt-8 px-16 small:px-6"
              });
  }
}

var make = QuestionText;

exports.make = make;
/* react/jsx-runtime Not a pure module */
